/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoTerm
 */
export interface GoTerm {
    /**
     * 
     * @type {string}
     * @memberof GoTerm
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GoTerm
     */
    term: string;
}

/**
 * Check if a given object implements the GoTerm interface.
 */
export function instanceOfGoTerm(value: object): value is GoTerm {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('term' in value) || value['term'] === undefined) return false;
    return true;
}

export function GoTermFromJSON(json: any): GoTerm {
    return GoTermFromJSONTyped(json, false);
}

export function GoTermFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoTerm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'term': json['term'],
    };
}

export function GoTermToJSON(json: any): GoTerm {
    return GoTermToJSONTyped(json, false);
}

export function GoTermToJSONTyped(value?: GoTerm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'term': value['term'],
    };
}

